export default __webpack_public_path__ + "static/media/pencil-pink-16px.8bb4d9d8.svg";